<template>
  <button
    :aria-label="ariaLabel"
    :id="elemId"
    @click="showPopup(videoUrl, elemId)"
    class="no-style"
  >
    <img :src="videoImage" alt="" class="img-responsive mx-auto cursor-pointer" />
  </button>
</template>

<script>
import store from '@/store/store';

export default {
  name: 'CustomVideo',
  props: {
    videoType: {
      type: String,
      default: 'iframe',
    },
    videoUrl: {
      type: String,
      required: true,
    },
    videoImage: {
      type: String,
      required: true,
    },
    elemId: {
      type: String,
      required: true,
    },
    ariaLabel: {
      type: String,
      required: true,
    },
  },
  methods: {
    showPopup(url, elemId) {
      if (this.videoType === 'iframe') {
        store.dispatch('popup/showIframePopup', url);
      } else {
        store.dispatch('popup/showVideoPopup', url);
      }
      store.commit('popup/setFocusElemOnPopupClose', elemId);
    },
  },
};
</script>

<style scoped></style>
